import { SiafLiteApiRepository, SiafLiteApiStream } from "../../external";
import store from "../../config/store";

class MonitorFinanceiroService {
  constructor() {
    this.urlBase = "financeiro/monitor-financeiro";
    this.urlBaseCompleta = `${store.baseUrl}/${this.urlBase}`;
  }

  getDashboardKpis(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-kpis`,
    ).patch(body);
  }

  getDashboardEntradasSaidas(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-entradas-saidas`,
    ).patch(body);
  }

  getDashboardFluxoPrevisto(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-fluxo-previsto`,
    ).patch(body);
  }

  getDashboardRankingDespesas(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-ranking-despesas`,
    ).patch(body);
  }

  getDashboardPrazosInadimplencia(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-prazos-inadimplencia`,
    ).patch(body);
  }

  getDashboardEntradasSaidasTotais(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-entradas-saidas-totais`,
    ).patch(body);
  }

  getDashboardRankingInadimplencia(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-ranking-inadimplencia`,
    ).patch(body);
  }

  getDashboardDre(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-dre`,
    ).patch(body);
  }

  getDashboardCiclo(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-ciclo`,
    ).patch(body);
  }

  gerarPdf(body) {
    return new SiafLiteApiStream(
      `${this.urlBaseCompleta}/relatorios/monitor-financeiro-pdf`,
    ).path(body);
  }
}

export default MonitorFinanceiroService;
